import { SidenavRow } from '@app/components/layout/sidenav/base';
import { ClientInfo } from '@app/components/layout/sidenav/client-info/ClientInfo';
import { AdminIndicator } from '@app/components/layout/sidenav/header/AdminIndicator';
import { AuthData } from '@app/core/auth/authentication/types';
import { UserRole } from '@mi-front/core';
import { Brand } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useState } from 'react';
import { config } from '../../../../config';

export function SidenavHeader(p: { auth: AuthData; collapsed: boolean }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box sx={{ paddingBottom: '0.5rem' }}>
      <SidenavRow
        sx={{
          marginBottom: '1.5rem',
          justifyContent: p.collapsed ? 'center' : undefined,
          position: 'relative',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box
          sx={{
            img: {
              height: '2rem',
            },
          }}
        >
          <Brand collapsed={p.collapsed} isAppDev={config.isAppDev} />
        </Box>
        <span
          style={{
            position: 'absolute',
            left: 8,
            top: -6,
            fontSize: 10,
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? 'translateY(0)' : 'translateY(-5px)',
            transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out',
            pointerEvents: 'none',
            color: '#ddd',
          }}
        >
          {config.appVersion}
        </span>
      </SidenavRow>
      {p.auth.user.role === UserRole.SUPERADMIN ? (
        <AdminIndicator />
      ) : (
        <ClientInfo client={p.auth.client!} />
      )}
    </Box>
  );
}
